import React from "react";
import { Box, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../use-stores";
import LivePreviewWrapper from "./LivePreviewWrapper";
import LoginPage from "./LoginPage";
import ProductsPage from "./ProductsPage";
import SwagstoreMockupsStep from "./SwagstoreMockupsStep";
import { SWAGSTORE_STEPS } from "../../../constants/SwagstoreConstants";

interface StorePreviewProps {
  settings?: any;
  selectedItem?: string;
  deviceView: "desktop" | "tablet" | "mobile";
  onDeviceViewChange: (view: "desktop" | "tablet" | "mobile") => void;
  previewWidth: string;
  loginPageImageUrl?: string;
  hideHeader?: boolean; // Option to hide the header in preview mode
  hidePreviewWrapper?: boolean; // Option to hide the LivePreviewWrapper in standalone preview
  isStandalonePreview?: boolean; // Option to indicate standalone preview (new tab)
}

const StorePreview: React.FC<StorePreviewProps> = ({
  selectedItem = SWAGSTORE_STEPS.BRANDING,
  deviceView,
  onDeviceViewChange,
  previewWidth,
  hideHeader = false,
  hidePreviewWrapper = false,
  isStandalonePreview = false,
}) => {
  const theme = useTheme();
  const { swagStoreStore } = useStores();
  
  // Get store background color from branding settings
  const storeBackgroundColor =
    swagStoreStore.settings.branding?.storeBackgroundColor ||
    theme.palette.customColors.white;

  if (selectedItem === SWAGSTORE_STEPS.MOCKUPS) {
    return (
      <Box
        sx={{
          flex: 1,
          height: { xs: "auto", lg: "100vh" },
          backgroundColor: storeBackgroundColor,
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: { xs: "100vh", lg: "auto" },
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <SwagstoreMockupsStep />
      </Box>
    );
  }

  const content = (
    <>
      {selectedItem === SWAGSTORE_STEPS.LOGIN ? (
        <LoginPage
          deviceView={deviceView}
          isStandalonePreview={isStandalonePreview}
        />
      ) : (
        <ProductsPage
          deviceView={deviceView}
          hideHeader={hideHeader}
          isStandalonePreview={isStandalonePreview}
        />
      )}
    </>
  );

  return (
    <Box
      sx={{
        flex: 1,
        height: { xs: "auto", lg: "100vh" },
        backgroundColor: storeBackgroundColor, // Use store background color
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: { xs: "100vh", lg: "auto" },
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {hidePreviewWrapper ? (
        <Box
          sx={{
            width: "100%",
            height: "100vh",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {content}
        </Box>
      ) : (
        <LivePreviewWrapper
          deviceView={deviceView}
          onDeviceViewChange={onDeviceViewChange}
          previewWidth={previewWidth}
        >
          {content}
        </LivePreviewWrapper>
      )}
    </Box>
  );
};

export default observer(StorePreview);
